module.exports = __webpack_public_path__ + "static/media/H_detectGraphImage3.e8b0c72d.png";